export const positiveHealthQuestionnaireAlias = 'positive-health';
